/* eslint-disable import/first */
import React from 'react';
import css from './index.module.scss';
import { Redux, Slices } from 'spwa-ui-library';
import { MenuItem, Button, Grid } from '@material-ui/core';
import { RiDeleteBinLine } from '@react-icons/all-files/ri/RiDeleteBinLine';
import { GrClose } from '@react-icons/all-files/gr/GrClose';
import DrawerPwa from '../../components/DrawerPwa';
const { selectBaseURL } = Slices.configSlice;
const { selectDesktop } = Slices.appSlice;
const { enableLightPay } = Slices.homeSlice;
import { numberWithSpaces, capitalizeFirstLetter } from 'spwa-ui-library/esm/utils/helper';
import { FormattedMessage } from 'react-intl';
import LightningPayToggle from '../../components/LightningPayToggle';
import DialogBox from '../../components/DialogBox';
import deleteIcon from './images/deleteCard.svg';
import EnableLightningPayModal from '../Checkout/EnableLightningPayModal';

/* eslint-disable import/first */

const { useSelector, useDispatch } = Redux;

const CardItem = ({ itemData, onDelete, fetchData, lightningPay }) => {
  const [deleteDrawer, setDeleteDrawer] = React.useState(false);
  const [enableLightningPay, setEnableLightningPay] = React.useState(false);

  const imgBaseUrl = useSelector(selectBaseURL);
  const dispatch = useDispatch();
  const isDesktop = useSelector(selectDesktop);
  const removeCard = () => {
    setDeleteDrawer(false);
    onDelete();
  };
  const maskTheCard = (cardNo) => {
    const newop = cardNo.replace(/.(?=.{4})/g, '•');
    return numberWithSpaces(newop, '####  ####  ####  ####');
  };
  const toggleLighteningPayHandler = (enable) => {
    setEnableLightningPay(false);
    const payload = {
      enableLightningPay: enable ? 1 : 0,
      token: itemData.token,
    };
    dispatch(enableLightPay(payload)).then((resp) => {
      fetchData(true);
    });
  };
  const deleteCardContent = () => {
    return (
      <div className={css.deleteMain}>
        <div className={css.deletePop}>
          <div className={css.closeButton} onClick={() => setDeleteDrawer(false)}>
            <GrClose size=".8em" />
          </div>
          <div className={css.inner}>
            {/* <Grid className={css.smdialogWidget}>
              <Grid className={css.redWidget} />
              <Grid className={css.redWidget} />
              <Grid className={css.redWidget} />
            </Grid> */}
            <h3 className={css.heading}>
              <img src={deleteIcon} alt={''} />
              <FormattedMessage id="profile_removeCard" defaultMessage="Remove Card" />
            </h3>
            <p className={css.content}>
              <FormattedMessage
                id="profile_areyouSure"
                defaultMessage="Are you sure you want to remove this Saved card?"
              />
            </p>
            <div className={css.buttons}>
              <Button
                color="primary"
                variant="outlined"
                size="medium"
                onClick={() => setDeleteDrawer(false)}
              >
                <FormattedMessage id="cart_cancel" defaultMessage="Cancel" />
              </Button>
              <Button
                color="primary"
                variant="contained"
                size="medium"
                onClick={() => removeCard()}
              >
                <FormattedMessage id="cart_confirm" defaultMessage="Yes, Confirm" />
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  };
  console.log(`itemData -- `, itemData);
  return (
    <>
      <div key={itemData.bldgName + '-' + itemData.id} className={css.cardItem}>
        <MenuItem key={1} className={css.deleteCard} onClick={() => setDeleteDrawer(true)}>
          <div className={css.deleteIcon}>
            <RiDeleteBinLine size={24} />
          </div>
        </MenuItem>
        <div className={css.cardWrapper}>
          <div className={css.cardContainer}>
            <div className={css.detail}>
              <p>
                {itemData?.type == 'CREDIT' ? (
                  <FormattedMessage id={'credit_card'} />
                ) : (
                  <FormattedMessage id={'debit_card'} />
                )}
              </p>
              <div className={css.cardNumber}>{maskTheCard(itemData.cardNo)}</div>
            </div>
          </div>
          <div className={css.cardIcon}>
            {lightningPay && (
              <div className={css.toggleContainer}>
                <LightningPayToggle
                  checkLightningPay={() => setEnableLightningPay(true)}
                  toggleLighteningPayHandler={toggleLighteningPayHandler}
                  checked={itemData.isLightningBlocked === 0}
                />
              </div>
            )}
            <img
              alt="brand logo"
              src={`${imgBaseUrl?.home}/py_card_fg_${itemData.brand.toLowerCase()}.png`}
              className={css.fgImage}
            />
          </div>
        </div>
      </div>
      {!isDesktop && (
        <DrawerPwa
          variant="temporary"
          anchor="bottom"
          hideCloseButton={true}
          open={deleteDrawer}
          className={css.menuList}
          onClose={() => setDeleteDrawer(false)}
        >
          {deleteCardContent()}
        </DrawerPwa>
      )}

      {isDesktop && deleteDrawer && deleteCardContent()}
      <DialogBox
        size="sm"
        isOpen={enableLightningPay}
        onClose={() => {
          setEnableLightningPay(false);
          fetchData(true);
        }}
      >
        <EnableLightningPayModal
          confirmLightningPay={() => toggleLighteningPayHandler(true)}
          onClose={() => {
            setEnableLightningPay(false);
          }}
        />
      </DialogBox>
    </>
  );
};

export default CardItem;
